module.exports = __webpack_public_path__ + "static/img/company_logo.6a2a282.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company_logo.png
// module id = trYg
// module chunks = 2